import { connect } from 'react-redux'
import { toggleSearch, closeSearch } from '../../actions'
import PlayerHeader from './PlayerHeader'

const mapStateToProps = (state) => {
  const { isActive: programmeSearchIsActive } = state.programmeSearch
  const {
    currentlySubscribed, firstName, lastName, targetedAdvertising, isLoggedIn, vipOptIn,
  } = state.user
  const { loginEnabled } = state.loginStatus
  return {
    programmeSearchIsActive,
    currentlySubscribed,
    firstName,
    lastName,
    targetedAdvertising,
    isLoggedIn,
    vipOptIn,
    loginEnabled,
  }
}

const mapDispatchToProps = {
  toggleSearch,
  closeSearch,
}

export default connect(mapStateToProps, mapDispatchToProps)(PlayerHeader)
